import { createContext, useContext, useReducer } from 'react';
import { PublicAmendmentSearchState, PublicAmendmentSearchReducer, ACTION_TYPES } from './public-amendment-search-reducer';

const PublicAmendmentSearchContext = createContext<PublicAmendmentSearchState | undefined>(undefined);
const PublicAmendmentSearchDispatchContext = createContext({} as any);

const PublicAmendmentSearchProvider = ({ children }: { children: React.ReactNode }) => {
    const initialState: PublicAmendmentSearchState = {
        parameters: { page: 0, pageSize: 20 },
        searchTrigger: 0,
    };
    const [state, dispatch] = useReducer(PublicAmendmentSearchReducer, initialState);
    return (
        <PublicAmendmentSearchContext.Provider value={state}>
            <PublicAmendmentSearchDispatchContext.Provider value={dispatch}>
                {children}
            </PublicAmendmentSearchDispatchContext.Provider>
        </PublicAmendmentSearchContext.Provider>
    );
};

const usePublicAmendmentSearchState = () => {
    const context = useContext(PublicAmendmentSearchContext);
    if (!context) throw new Error('usePublicAmendmentSearchState must be used within PublicAmendmentSearchProvider');
    return context;
};

const usePublicAmendmentSearchDispatch = () => {
    const context = useContext(PublicAmendmentSearchDispatchContext);
    if (!context) throw new Error('usePublicAmendmentSearchDispatch must be used within PublicAmendmentSearchProvider');
    return context;
};

export { PublicAmendmentSearchProvider, usePublicAmendmentSearchState, usePublicAmendmentSearchDispatch, ACTION_TYPES };
